// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"dq-z","slideIn":"eq-z"};